import React from 'react';
import { Dialog } from '@reach/dialog';
import '@reach/dialog/styles.css';
import styles from './styles.scss';

function Modal(_ref) {
  var className = _ref.className,
      isOpen = _ref.isOpen,
      onDismiss = _ref.onDismiss,
      children = _ref.children,
      label = _ref.label;
  return /*#__PURE__*/React.createElement(Dialog, {
    className: "".concat(styles.overlay, " ").concat(className),
    isOpen: isOpen,
    onDismiss: onDismiss,
    "aria-label": label
  }, children);
}

Modal.defaultProps = {
  className: null,
  isOpen: false,
  label: 'Modal',
  onDismiss: function onDismiss() {}
};
export default Modal;